
<script>
    export default {
        props: ['data'],
        components: {
        },
        data () {
            return {
            }
        }
    };
</script>
<template>
    <div class="page-wrapper section-space--inner--80">
        <div class="blog-section">
            <div class="container">
                <!-- <div class="row section-space--bottom--40">
                    <div class="col-sm-12 text-center">
                        <h3 class="text-color-green font-size-24">Visi & Misi</h3>
                        <h2>Visi & Misi SMA Negeri Indonesia</h2>
                        <p class="font-size-15">Visi & Misi SMA Negeri Indonesia Tahun 2020/2021</p>
                    </div>
                </div> -->
                <div class="row mb-5">
                    <div class="col-sm-12">
                        <h3 class="text-color-green font-size-30">Visi</h3>
                        <div v-html="data.vission.body"></div>
                    </div>
                </div>
               <div class="row mb-5">
                    <div class="col-sm-12">
                        <h3 class="text-color-green font-size-30">Misi</h3>
                        <div v-html="data.mission.body"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
  .list-style {
    list-style: square;
    margin-left: 40px;
  }
  
</style>
